import { nextTick, shallowRef } from "vue";
import type { DynamicComponentOptions } from "@/lib/typing/types";

const contextMenu = shallowRef<DynamicComponentOptions>();

const showContextMenu = (fields: DynamicComponentOptions) => {
  contextMenu.value = undefined;
  nextTick(() => {
    contextMenu.value = fields;
  });
};

export default function useContextMenu() {
  return { contextMenu, showContextMenu };
}